import { classes, stylesheet } from 'typestyle'

/* Common ======================================================================================= */
import useValue from '../../__aeki__/hooks/use-value'

/* Components =================================================================================== */
import { Box } from '../../__aeki__/components/box/box.component'
import { Button } from '../../__aeki__/components/button'
import { Heading } from '../../__aeki__/components/text/heading.component'
import { Line } from '../../__aeki__/components/line'
import { Modal } from '../../__aeki__/components/modal'
import { Text } from '../../__aeki__/components/text/text.component'
import { TextField } from '../../__aeki__/components/text-field'

/* Styles ======================================================================================= */
import { p12 } from '../../__aeki__/styles/styleset/padding/p12'
import { ml4 } from '../../__aeki__/styles/styleset/margin/ml4'

Modal.add('Time', (props: any) => {
  const [value, $value] = useValue(props.value || '')

  const onClose = () => Modal.pop()
  const onSubmit = () => {
    if (value) {
      const refDate = new Date()

      refDate.setHours(value.split(':')[0])
      refDate.setMinutes(value.split(':')[1])

      props.onSubmit(refDate.toISOString())
    }
    Modal.pop()
  }

  return (
    <Box
      className={classes(STYLES.parent)}
      maxWidth={320}
      rounded
      fullWidth
      fullHeight
      alignCenter
      row
    >
      <Box className={classes(p12)} baseline="none" fullWidth row>
        {props.subtitle && (
          <Text baseline="surface" lighter size="sm">
            {props.subtitle}
          </Text>
        )}
        <Heading size="xs">{props.title}</Heading>
      </Box>
      <Line />
      <Box className={p12} baseline="none">
        <TextField type="time" onChange={value => $value.set(value)} value={value} />
      </Box>
      <Line />
      <Box className={p12} alignRight baseline="none">
        <Button square label="Cancel" size="sm" onClick={onClose} />
        <Button
          disabled={!$value}
          square
          label="Save"
          className={ml4}
          baseline="primary"
          size="sm"
          onClick={onSubmit}
        />
      </Box>
    </Box>
  )
})

const STYLES = stylesheet({
  parent: {
    backgroundColor: 'none',
  },
  container: {
    backgroundColor: 'none',
    borderRadius: '8px 8px 0 0',
  },
})
